import Swal from 'sweetalert2';

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + "; path=/" + expires;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function checkUserCountry() {
  if (getCookie("pawzler_no_redirect") === "true") {
    return;
  }

  fetch('/wp-admin/admin-ajax.php?action=get_user_country')
    .then(response => response.json())
    .then(data => {
      if (data.country === 'US') {
        Swal.fire({
          html: pawzler_object.us_popup_html,
          width: 845,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: "Go to US Store",
          cancelButtonText: "Stay here",
          focusConfirm: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "https://us.pawzler.com";
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            setCookie("pawzler_no_redirect", "true", 30); // Save for 30 days
          }
        });
      } else {
        setCookie("pawzler_no_redirect", "true", 30);
      }
    })
    .catch(error => console.error('Error fetching country:', error));
}

document.addEventListener('DOMContentLoaded', checkUserCountry);
